export default "__VITE_ASSET__Bckfc3XK__"